import React from "react";
import { getLiturgicalYear } from "../../calendar/utils";
import { HORIZONTAL_RULE_COLOR } from "../../tokens";
import { PsalmCycleSetting, ReadingsSetting } from "../../utils/settings";
import { CheckLessonsRow } from "./CheckLessonsRow";
import { CheckPsalmsRow } from "./CheckPsalmsRow";

const psalmTableList: PsalmCycleSetting[] = ["bcp", "acna", "cw"];

const readingsTableList: ReadingsSetting[] = [
    "1922-morning",
    "1922-evening",
    "1871-morning",
    "1871-evening",
    "cw-morning",
    "cw-evening",
    "acna-morning-short",
    "acna-evening-short",
];

export const CheckPage: React.FC<{}> = () => {
    const dateTime = new Date();

    const date = dateTime.getDate();
    const month = dateTime.getMonth() + 1;
    const year = dateTime.getFullYear();

    const psalmTables = psalmTableList.map((section) => {
        let foundToday = false;
        let daysPrinted = 0;

        const rows = getLiturgicalYear(year, true)
            .days.concat(getLiturgicalYear(year + 1, true).days)
            .map((day) => {
                if (
                    day.date === date &&
                    day.month === month &&
                    day.year === year
                ) {
                    foundToday = true;
                }

                if (foundToday && daysPrinted < 30) {
                    daysPrinted++;

                    return (
                        <>
                            <CheckPsalmsRow day={day} cycle={section} />
                        </>
                    );
                } else {
                    return <></>;
                }
            });

        return (
            <div
                style={{
                    borderTop: `1px solid ${HORIZONTAL_RULE_COLOR}`,
                }}
            >
                <div
                    style={{
                        fontSize: "120%",
                        fontWeight: "bold",
                        padding: 8,
                    }}
                >
                    Psalms: {section}
                </div>
                {rows}
            </div>
        );
    });

    const lessonTables = readingsTableList.map((section) => {
        let foundToday = false;
        let daysPrinted = 0;

        const rows = getLiturgicalYear(year, true)
            .days.concat(getLiturgicalYear(year + 1, true).days)
            .map((day) => {
                if (
                    day.date === date &&
                    day.month === month &&
                    day.year === year
                ) {
                    foundToday = true;
                }

                if (foundToday && daysPrinted < 30) {
                    daysPrinted++;

                    return (
                        <>
                            <CheckLessonsRow day={day} readings={section} />
                        </>
                    );
                } else {
                    return <></>;
                }
            });

        return (
            <div
                style={{
                    borderTop: `1px solid ${HORIZONTAL_RULE_COLOR}`,
                }}
            >
                <div
                    style={{
                        fontSize: "120%",
                        fontWeight: "bold",
                        padding: 8,
                    }}
                >
                    {section}
                </div>
                {rows}
            </div>
        );
    });

    return (
        <>
            {psalmTables}
            {lessonTables}
        </>
    );
};
